import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const DepartmentCreateForm= React.lazy(()=>import('./CreateForm'))
const DepartmentEditPage= React.lazy(()=>import('./EditPage'));
const DepartmentListingPage= React.lazy(()=>import('./DepartmentListing'))
const DepartmentDetailPage= React.lazy(()=>import('./DetailPage'));


export const DepartmentConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/department/create',
    element: <DepartmentCreateForm />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/department/edit/:id',
    element: <DepartmentEditPage />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/department/details/:id',
    element: <DepartmentDetailPage />,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/department/list',
    element: <DepartmentListingPage/>,
  },
 

];
